export const useLoginRedirect = () => {
  const route = useRoute()
  const localePath = useLocalePath()

  /** Login route object, automatically carries redirect=current page */
  const loginRoute = computed(() => ({
    path: localePath('/login'),
    query: { redirect: route.fullPath }
  }))

  /** Register route object, automatically carries redirect=current page */
  const registerRoute = computed(() => ({
    path: localePath('/register'),
    query: { redirect: route.fullPath }
  }))

  /** Programmatic navigation to login page */
  function navigateToLogin() {
    return navigateTo(loginRoute.value)
  }

  return { loginRoute, registerRoute, navigateToLogin }
}
